/**
 * basemap — the one basemap URL the app draws on.
 *
 * The main map has always used MapTiler **hybrid** (satellite + labels), but the
 * admin console's own maps were written separately and reached for **streets**.
 * That made the console quietly misleading: an operator would place an org's
 * initial view, or style its boundary, against a street map, and then every user
 * of that org would see the result over satellite imagery. A colour that reads
 * well on pale streets can vanish over dark vegetation.
 *
 * So every map that is previewing something users will see uses this. The one
 * deliberate exception is a map choosing between basemaps for its own sake
 * (`PreviewMap`'s `mapStyle` prop), which is offering the choice, not assuming it.
 */

/** MapTiler style URL for a named style, or the free demo tiles with no key set. */
const maptiler = (style: string): string =>
  process.env.REACT_APP_MAPTILER_KEY
    ? `https://api.maptiler.com/maps/${style}/style.json?key=${process.env.REACT_APP_MAPTILER_KEY}`
    : "https://demotiles.maplibre.org/style.json";

/**
 * What the app's main map renders on, and therefore what any preview of the app
 * must render on to be honest about how something will look.
 */
export const APP_BASEMAP_STYLE = maptiler("hybrid");
